import React from "react";
import { string } from "yup";
import MxRichEditor, {
  MxRichEditorProps
} from "@rf-l1/form/text-fields/MxTextQuillField";
import { useMxFieldControllerContext } from "../../../../context/MxFieldController";
type omit = "name";
export type MxFormTextQuillFieldProps = Omit<MxRichEditorProps, omit> & {
  // Optional extra handler: runs after RHF onBlur
  onAfterBlur?: (e: { target: { name: string; value: string } }) => void;
};
const MxFormTextQuillField = (props: MxFormTextQuillFieldProps) => {
  const { ...rest } = props;
  const ref = React.useRef<HTMLDivElement>(null);
  const { onChange, onBlur, name, value, invalid, id, inputRef } =
    useMxFieldControllerContext();
  return (
    <MxRichEditor
      {...rest}
      onChange={onChange}
      formRef={ref}
      onBlur={e => {
        onBlur(e);
        // fire external hook after RHF blur
        props.onAfterBlur?.(e);
      }}
      error={invalid}
      value={value}
      name={name}
      innerRef={inputRef}
    />
  );
};

export default MxFormTextQuillField;
